<template>
  <div>
    <div class="label-create-form-data">CREATE MULTIPLE EXPERIENCE MANAGER</div>
    <b-row>
      <b-col cols="12">
        <div>
          <b-form-group :class="{'error-input' : $v.dataForm.name.$error}">
            <label for="name"> Name </label>
            <j-input
              id="name"
              v-model="$v.dataForm.name.$model"
              placeholder="Enter name here"/>
          </b-form-group>
          <div>
            <div class="float-right">
              <b-button
                class="btn m__r--5"
                @click="closeModal">
                Close
              </b-button>
              <b-button
                class="btn blue"
                @click="submitForm">
                Next
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  validations: {
    dataForm: {
      name: {
        required,
      },
    },
  },
  data() {
    return {
      dataForm: {
        name: null,
      },
    };
  },
  created() {
    this.dataForm = {
      name: null,
    };

    this.$v.dataForm.$reset();
  },
  methods: {
    ...mapActions('jStoreFormUi', ['actionSetMultiForm']),

    async submitForm() {
      this.$v.dataForm.$touch();
      if (!this.$v.dataForm.$error) {
        const { name } = this.dataForm;
        const params = {
          name,
        };
        const res = await this.actionSetMultiForm(params);
        if (!res.error) {
          this.closeModal();
          this.$router.push(`/multiple-experience-manager/update/${res.data.id}`);
        }
      }
    },
    closeModal() {
      this.dataForm = {
        name: null,
      };
      this.$v.dataForm.$reset();
      this.$emit('close-modal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager/jMultipleFormUiCreate.vue